import SearchReference from '@/components/organisms/search-reference-cesde/searchReference';
import { graphql, useStaticQuery } from 'gatsby';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';

const ReferenciaPagoCesde = () => {
    const data = useStaticQuery(graphql`
        query GET_CONSULTA_REFERENCIA_PAGO_CESDE {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Interna de certificados y documentos > Consulta referencia para pago CESDE"
                    }
                }
            ) {
                nodes {
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                            file {
                                url
                            }
                        }
                        urlCanonical
                        noIndex
                    }
                    migaDePan
                    nombre
                    subtitulo
                    estaActivo
                    referencias {
                        ... on ContentfulTemplate {
                            nombre
                            subtitulo
                            tituloEnriquecido {
                                raw
                            }
                            descripcion {
                                raw
                            }
                            nombreEmpresa
                            spanMagenta
                            lista
                            imagen {
                                title
                                file {
                                    url
                                }
                                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                svg {
                                    publicURL
                                }
                            }
                            referencias {
                                ... on ContentfulTemplate {
                                    nombre
                                    subtitulo
                                    tituloEnriquecido {
                                        raw
                                    }
                                    nombreEmpresa
                                    lista
                                    spanMagenta
                                    listaJson {
                                        name
                                        value
                                    }
                                    imagen {
                                        title
                                        file {
                                            url
                                        }
                                        gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                        svg {
                                            publicURL
                                        }
                                    }
                                }
                            }
                            boton {
                                copy
                                redireccion
                            }
                        }
                    }
                    modal {
                        imagen {
                            title
                            file {
                                url
                            }
                            gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                        }
                        spanMagenta
                        nombre
                        subtitulo
                        boton {
                            copy
                            redireccion
                        }
                    }
                }
            }
        }
    `);

    const metaData = data?.allContentfulTemplate?.nodes[0]?.metaInfo[0];
    const content = data?.allContentfulTemplate?.nodes[0];
    return (
        <GeneralPageTemplate
            data={metaData}
            hasLoader={true}
            hideSide={true}
            isPrivate={false}
            isActive={content?.estaActivo}
        >
            <SearchReference contentInfo={content} />
        </GeneralPageTemplate>
    );
};

export default ReferenciaPagoCesde;
